import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';
import HeroSection from './components/HeroSection';
import UseCasesSection from './components/UseCasesSection';
import GallerySection from './components/GallerySection';
import WhySection from './components/WhySection';
import CitiesSection from '@/components/feature/CitiesSection';
import OrderSection from './components/OrderSection';

export default function CanopiesPage() {
  return (
    <>
      <Navbar />
      <main className="pb-16 md:pb-0">
        <HeroSection />
        <UseCasesSection />
        <GallerySection />
        <WhySection />
        <CitiesSection productName="Навесы" productPath="/products/canopies" />
        <OrderSection />
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}